var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full"},[_c('article',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h3',{staticClass:"my-0",domProps:{"textContent":_vm._s('No results')}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }